import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseFormErrorTranslateService } from './form-common-error/base-form-error-translate.service';
// tslint:disable-next-line:max-line-length

@Injectable()
export class ErrorTranslateService extends BaseFormErrorTranslateService {
  constructor(private translateService: TranslateService) {
    super();
  }

  translate(key: string, errorDetail?: any): string {
    let label = this.translateService.instant(`forms.errors.${key}`);
    for (const prop of Object.getOwnPropertyNames(errorDetail)) {
      label = this.translateService.instant(`forms.errors.${key}`, {
        requiredLength: errorDetail[prop] + 1
      });
    }
    return label;
  }
}
